<template>
    <div class="page">
    	<div class="title">
        	<h2>Documentos</h2>    		
    	</div>
        <div class="row">        	
            <div class="sm-12">
            	<div class="subtitle">
                    <h3>Enviar Documentos</h3>
                    <form @submit.prevent.stop="salvar">
                        <div class="row">
                            <div class="sm-12 md-6">
                                <label>
                                    Categoria
                                    <select v-model="categoriadocumento_id">                                        
                                        <option :value="categoria.id" v-for="categoria in categorias" :key="categoria.id">{{ categoria.titulo }}</option>
                                    </select>
                                </label>
                            </div>
                            <div class="sm-12 md-6">
                                <label>
                                    Título
                                    <input type="text" v-model="titulo" required >
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="sm-12">
                                <label>
                                    Descrição
                                    <textarea v-model="descricao"></textarea>
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="sm-12">
                                <Dropzone v-model="arquivos"></Dropzone>
                            </div>
                        </div>
                        <div class="row">
                            <div class="sm-12">
                                <button class="default-button" v-if="salvando">
                                    Salvando
                                    <i class="mdi mdi-loading mdi-spin"></i>
                                </button>
                                <button class="default-button" v-else>
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </form>
                    <p><strong>Importante:</strong> Esta área é destinada exclusivamente para documentos do condomínio e são de responsabilidade única e exclusiva de quem os coloca.</p>
                </div>          
            </div>
        </div>
    </div>
</template>
<script>
import instance from '/plugins/api';
import Dropzone from '../../../components/Dropzone.vue';
import Swal from 'sweetalert2';
export default {
    components: {        
        Dropzone
    },
    data() {
        return {
            salvando: false,
            loading: true,
            errors: [],
            categorias: [],
            arquivos: [],
            categoriadocumento_id: 0,
            titulo: '',
            descricao: '',
            anexos: []
        }
    },
    computed: {
        id() {
            return this.$route.params.id | 0;
        },
        condominio() {
            return this.$store.getters.condominio;
        },
        cliente() {
            return this.$store.state.cliente;
        }
    },
    methods: {
        async loadCategorias() {
            try {
                let { data: categorias } = await instance.get('dados-condominos/documentos/categorias');
                categorias.sort((a,b) => a.titulo < b.titulo ? -1 : 1)
                this.categorias = categorias;
                if (categorias.length != 0 && +this.id === 0) {
                    let [categoria] = categorias;
                    this.categoriadocumento_id = categoria.id;
                }
            } catch (err) {
                this.errors = [...this.errors, err];
            }
        },
        async loadDocumento() {
            try {
                if (+this.id === 0) {
                    return;
                }
                let { data: documento } = await instance.get(`dados-condominos/documentos/${this.id}`);
                this.documento = documento;
                this.categoriadocumento_id = documento.categoriadocumento_id;
                this.titulo = documento.titulo;
                this.descricao = documento.descricao;


            } catch (err) {
                this.errors = [...this.errors, err];
            }
        },
        async loadAnexos() {
            try {
                if (+this.id === 0) {
                    return;
                }
                let { data: categorias } = await instance.get(`dados-condominos/documentos/${this.id}/arquivos`);
                this.categorias = categorias;
                if (categorias.length != 0) {
                    let [categoria] = categorias;
                    this.categoriadocumento_id = categoria.id;
                }
            } catch (err) {
                this.errors = [...this.errors, err];
            }
        },
        async loadData() {
            this.loading = true;
            this.categorias = [];
            this.documento = null;
            this.arquivos = [];
            this.errors = [];

            await Promise.all([
                this.loadCategorias(),
                this.loadDocumento(),
                this.loadAnexos()
            ]);
            this.loading = false;
        },
        async salvar() {
            try {
                if (this.salvando) {
                    return;
                }
                
                let categoriadocumento_id = +this.categoriadocumento_id;
                let titulo = this.titulo;
                let descricao = this.descricao;
                let arquivos = this.arquivos;

                this.salvando = true;
                
                let { data: documento } = await instance.post(`dados-condominos/documentos`, {
                    id: +this.id,
                    categoriadocumento_id,
                    titulo,
                    descricao,
                    codigo_condominio: +this.condominio.codigo,
                    codigo_sindico: +this.cliente.codigo,
                    codigo_cliente: +this.cliente.codigo,
                });

                for(let file of arquivos) {
                    let formData = new FormData();
                    formData.append('arquivo', file);
                    let resp = await instance.post(`dados-condominos/documentos/${documento.id}/arquivos/${file.uid}`, formData);
                }

                this.$router.replace(`/dados-condominos/documentos/visualizar/${documento.id}`);

            } catch (err) {
                const text = err?.response?.data?.error || "Não foi possível salvar o registro"
                Swal.fire({
                    icon: 'error',
                    title: "Opps",
                    text
                });
            }
            this.salvando = false;
        }
    },
    watch: {
        id: {
            immediate: true,
            handler() {
                this.loadData();
            }
        }
    }
}
</script>